import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=7660dac8&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7660dac8')) {
      api.createRecord('7660dac8', component.options)
    } else {
      api.reload('7660dac8', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=7660dac8&", function () {
      api.rerender('7660dac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Tab.vue"
export default component.exports